var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpgFallback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.645,21.911L19.111,14.444V18.2H21.334V10.667H13.8V12.889H17.523L10.089,20.322L11.645,21.911ZM16,29.333C14.171,29.333 12.445,28.983 10.823,28.283C9.2,27.583 7.786,26.63 6.578,25.422C5.371,24.215 4.417,22.8 3.717,21.178C3.017,19.555 2.667,17.83 2.667,16C2.667,14.156 3.017,12.422 3.717,10.8C4.417,9.178 5.371,7.767 6.578,6.567C7.786,5.367 9.2,4.417 10.823,3.717C12.445,3.017 14.171,2.667 16,2.667C17.845,2.667 19.578,3.017 21.2,3.717C22.823,4.417 24.234,5.367 25.434,6.567C26.634,7.767 27.584,9.178 28.284,10.8C28.984,12.422 29.334,14.156 29.334,16C29.334,17.83 28.984,19.555 28.284,21.178C27.584,22.8 26.634,24.215 25.434,25.422C24.234,26.63 22.823,27.583 21.2,28.283C19.578,28.983 17.845,29.333 16,29.333Z",
    fill: "#55A7F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpgFallback);
export default __webpack_public_path__ + "static/media/spgFallback.60db3737506afe8ad75e20aa3e2acd8b.svg";
export { ForwardRef as ReactComponent };